import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

export default class AssignToButton extends Component {
  render() {
    return (
      <div
        className="assign-this-quest-to button btn-secondary-small"
        onClick={this.props.handleClick}
      >
        <FormattedMessage
          id={'Quest.Review.AssignmentArea.AssignThisQuestTo'}
          defaultMessage={'Assign this quest to...'}
        />
      </div>
    )
  }
}

AssignToButton.propTypes = {
  handleClick: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/assignment/AssignToButton.js